import { ProductsState } from './types';
import * as constants from './constants';

/* eslint-disable no-alert, @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unsafe-assignment */
const getInitialState = (): ProductsState => {
  let lsBasketData = {};
  try {
    lsBasketData = JSON.parse((window as any).localStorage.getItem('basketDataDC'));
  } catch (error) {
    lsBasketData = null;
    console.warn('There was a problem with LS', error);
  }
  return {
    filters: [],
    subformats: [],
    productsByGroups: [],
    productsByUrn: {},
    searchGroupFormat: '',
    possibleBookingDates: [],
    industriesBig5: [],
    batchEditFailedCount: 0,
    productFiltersDataByUrn: {},
    productFiltersByUrn: {},
    basket: {
      id: null,
      isBasketOpen: false,
      reference: null,
      basketProducts: {
        productsByUrn: {},
        productsById: {},
        products: [],
        groupedProductsByCity: {},
        groupedProducts: [],
        stats: {},
      },
      ...lsBasketData,
    },
    batchSelect: {
      selectedGroupsIds: [],
      selectedProductUrns: [],
    },
    selectedFilters: {
      tags: {},
      networks: [],
    },
    notices: {},
    abortControllers: [],
  };
};

export const productsReducer = (state: ProductsState = getInitialState(), action: any) => {
  switch (action.type) {
    case constants.FETCH_PRODUCTS:
      let subformats = [];
      let productsByUrn = {};
      // Netzkombis ergänzen
      const addEmptyCombiPanels = action.usedTypes && action.usedTypes.length === 1;

      for (const productTypeGroup of action.payload.data.elements) {
        if (
          addEmptyCombiPanels &&
          (productTypeGroup.groupvalue === 'ePanel' || productTypeGroup.groupvalue === 'eBoard')
        ) {
          subformats.push('Kombi-Netze ' + productTypeGroup.groupvalue + ' CH');
        }
        if (productTypeGroup.subgroup) {
          for (const level2group of productTypeGroup.subgroup.elements) {
            subformats.push(level2group.groupvalue);
            if (level2group.products) {
              for (const product of level2group.products) {
                productsByUrn[product.producturn] = product;
              }
            }
          }
        }
      }
      let productsByGroups = action.payload?.data?.elements || [];
      if (addEmptyCombiPanels) {
        if (action.usedTimeslot < 10) {
          productsByGroups[0].subgroup.elements.unshift({
            groupvalue: 'Kombi-Netze ePanel CH',
            products: [],
            count: -1,
          });
        }
        productsByGroups[1].subgroup.elements.unshift({
          groupvalue: 'Kombi-Netze eBoard CH',
          products: [],
          count: -1,
        });
      }
      return {
        ...state,
        subformats: subformats,
        productsByUrn: productsByUrn,
        productsByGroups: productsByGroups,
        productFiltersByUrn: {},
        productFiltersDataByUrn: {},
        batchSelect: {
          selectedGroupsIds: [],
          selectedProductUrns: [],
        },
        selectedFilters: {
          networks: subformats,
          tags: state.selectedFilters.tags,
        },
      };

    case constants.GET_FILTERS:
      return {
        ...state,
        filters: action.payload.data,
      };

    case constants.FETCH_BOOKING_DATES:
      return {
        ...state,
        possibleBookingDates: action.payload.data,
      };

    case constants.FETCH_INDUSTRIES_BIG5:
      return {
        ...state,
        industriesBig5: action.payload.data,
      };

    case constants.SET_PRODUCT_FILTER_DATA:
      const newProductFiltersByUrn = { ...state.productFiltersByUrn };
      const productFiltersDataByUrn = {
        ...state.productFiltersDataByUrn,
      };

      if (action.payload?.data?.swapAndDelete) {
        if (action.payload?.data?.producturn) {
          productFiltersDataByUrn[action.payload?.data?.producturn] = {
            ...state.productFiltersDataByUrn[action.payload?.data?.producturn],
            ...state.productFiltersDataByUrn[action.payload.producturn],
          };
          delete productFiltersDataByUrn?.[action.payload.producturn];
        }
      } else {
        if (Object.keys(action.payload.data).length === 0) {
          delete newProductFiltersByUrn?.[action.payload.producturn];
          delete productFiltersDataByUrn?.[action.payload.producturn];
        } else {
          newProductFiltersByUrn[action.payload.producturn] = {
            ...state.productFiltersByUrn[action.payload.producturn],
            ...action.payload.data,
          };
        }
      }
      return {
        ...state,
        productFiltersByUrn: newProductFiltersByUrn,
        productFiltersDataByUrn: productFiltersDataByUrn,
      };

    case constants.CLEAR_PRODUCT_FILTER_DATA: {
      return {
        ...state,
        productFiltersByUrn: {},
        batchSelect: {
          selectedGroupsIds: [],
          selectedProductUrns: [],
        },
      };
    }

    case constants.FETCHED_BOOKING_DATES: {
      return {
        ...state,
        possibleBookingDates: action.payload.data,
      };
    }

    case constants.UPDATE_BATCH_EDIT_FAILED_COUNT: {
      return {
        ...state,
        batchEditFailedCount: action.payload,
      };
    }

    case constants.FETCHED_PRODUCT_PRICE: {
      let producturn = action.payload.subproducturn || action.payload.data?.producturn;
      return {
        ...state,
        productFiltersDataByUrn: {
          ...state.productFiltersDataByUrn,
          [producturn]: {
            ...state.productFiltersDataByUrn[producturn],
            pricefordates: action.payload.data.prices,
          },
        },
      };
    }
    case constants.CALCULATE_SHARE_OF_TIME: {
      let producturn = action.payload.subproducturn || action.payload.data?.producturn;
      return {
        ...state,
        productFiltersDataByUrn: {
          ...state.productFiltersDataByUrn,
          [producturn]: {
            ...state.productFiltersDataByUrn[producturn],
            ...action.payload.data,
          },
        },
      };
    }

    case constants.FETCHED_DIGITAL_PRODUCT_AVAILABILITY: {
      return {
        ...state,
        productsByUrn: {
          ...state.productsByUrn,
          [action.payload.data.producturn]: {
            ...state.productsByUrn[action.payload.data.producturn],
            availabilities: action.payload.data.availability,
            rating: action.payload.data.rating,
          },
        },
      };
    }

    case constants.CREATE_BASKET: {
      const response = action.payload.data;
      const newBasket = {
        id: response.basket,
        reference: response.basketreference,
      };

      localStorage.setItem('basketDataDC', JSON.stringify(newBasket));

      return {
        ...state,
        basket: {
          ...state.basket,
          id: newBasket.id,
          reference: newBasket.reference,
        },
      };
    }

    case constants.UPDATE_BASKET_DATA: {
      const response = action.payload.data;
      const basketData = {
        ...response,
        id: response.id,
        reference: response.basketreference,
      };
      return {
        ...state,
        basket: {
          ...state.basket,
          ...basketData,
        },
      };
    }

    case constants.UPDATE_BASKET_DEFINITION: {
      return {
        ...state,
        basket: {
          ...state.basket,
          basketProducts: {
            ...state.basket.basketProducts,
            stats: action.payload.data.summary,
            definition: action.payload.data,
          },
        },
      };
    }

    case constants.ADD_TO_BASKET: {
      return {
        ...state,
      };
    }

    case constants.OPEN_BASKET: {
      return {
        ...state,
        basket: {
          ...state.basket,
          isBasketOpen: true,
        },
      };
    }

    case constants.CLEAR_BASKET: {
      return {
        ...state,
        basket: {
          ...state.basket,
          basketProducts: {
            productsByUrn: {},
            productsById: {},
            products: [],
            groupedProductsByCity: {},
            groupedProducts: [],
            stats: {},
          },
        },
      };
    }

    case constants.REMOVE_BASKET_DATA: {
      return {
        ...state,
        basket: {
          id: null,
          isBasketOpen: false,
          reference: null,
          basketProducts: {
            productsByUrn: {},
            productsById: {},
            products: [],
            groupedProductsByCity: {},
            groupedProducts: [],
            stats: {},
          },
        },
      };
    }

    case constants.CLOSE_BASKET: {
      return {
        ...state,
        basket: {
          ...state.basket,
          isBasketOpen: false,
        },
      };
    }

    case constants.FETCH_BASKET: {
      let productsArray = [];
      let productsByUrn = {};
      let productsById = {};
      let groupedProductsByCity = {};

      action.payload.data.groupedproducts.elements.forEach(({ subgroup }) => {
        subgroup.elements.forEach(({ subgroup: { elements }, groupvalue, count, countinvalidstate }) => {
          const current = groupedProductsByCity[groupvalue];
          groupedProductsByCity[groupvalue] = current
            ? {
                ...current,
                count: current.count + count,
                elements: [...current.elements, ...elements],
                countinvalidstate: countinvalidstate,
              }
            : {
                groupvalue,
                count,
                elements,
                countinvalidstate,
              };

          elements.forEach(({ products }) => {
            products.forEach((product) => {
              productsByUrn[product.producturn] = product;
              productsById[product.basketentryid] = product;
              productsArray.push(product);
            });
          });
        });
      });

      const basketProducts = {
        productsByUrn,
        productsById,
        products: [...productsArray],
        groupedProductsByCity,
        groupedProducts: action.payload.data.groupedproducts.elements,
        stats: action.payload.data.summary,
        definition: action.payload.data.definition,
      };

      return {
        ...state,
        basket: {
          ...state.basket,
          basketProducts,
        },
      };
    }

    case constants.RESET_ALL: {
      return {
        ...state,
        productsByUrn: {},
        productFiltersByUrn: {},
        productsByGroups: [],
        subformats: [],
        searchGroupFormat: '',
        products: [],
        basket: {
          products: {},
          total: 0,
        },
      };
    }

    case constants.BATCH_SELECT_GROUP:
      const { groupId, productIds } = action.payload;
      return {
        ...state,
        batchSelect: {
          ...state.batchSelect,
          selectedGroupsIds: [...state.batchSelect.selectedGroupsIds, groupId],
          selectedProductUrns: [...new Set([...state.batchSelect.selectedProductUrns, ...productIds])],
        },
      };
    case constants.BATCH_SELECT_PRODUCT:
      return {
        ...state,
        batchSelect: {
          ...state.batchSelect,
          selectedProductUrns: [...new Set([...state.batchSelect.selectedProductUrns, action.payload])],
        },
      };
    case constants.BATCH_DESELECT_GROUP:
      const deselectedProductUrns = state.batchSelect.selectedProductUrns.filter(
        (urn) => !action.payload.productIds.includes(urn),
      );
      return {
        ...state,
        batchSelect: {
          ...state.batchSelect,
          selectedGroupsIds: state.batchSelect.selectedGroupsIds.filter((id) => id !== action.payload.groupId),
          selectedProductUrns: deselectedProductUrns,
        },
      };
    case constants.BATCH_DESELECT_PRODUCT:
      return {
        ...state,
        batchSelect: {
          ...state.batchSelect,
          selectedProductUrns: state.batchSelect.selectedProductUrns.filter((urn) => urn !== action.payload),
        },
      };

    case constants.DESELECT_ALL_PRODUCTS_AND_GROUPS:
      return {
        ...state,
        batchSelect: {
          selectedGroupsIds: [],
          selectedProductUrns: [],
        },
      };
    case constants.FILTERING_PRODUCTS:
      return {
        ...state,
        selectedFilters: action.payload,
      };
    case constants.CLEAR_FILTERED_PRODUCTS:
      return {
        ...state,
        selectedFilters: {
          tags: {},
          networks: state.subformats,
        },
      };
    case constants.CLEAR_FILTERED_PRODUCTS_BY_TYPE:
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          [action.payload]: [],
        },
      };
    case constants.SELECT_ALL_FILTERED_PRODUCTS_BY_TYPE:
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          [action.payload.type]: action.payload.values,
        },
      };
    case constants.NOTICE_RECEIVED: {
      return {
        ...state,
        notices: {
          ...state.notices,
          [action.payload.code]: {
            code: action.payload.code,
            message: action.payload.message,
            status: action.payload.status,
            productUrn: action.payload.productUrn,
            value: action.payload.value,
            data: action.payload?.data,
          },
        },
      };
    }
    case constants.CLEAR_NOTICES: {
      let newNotices = { ...state.notices };
      if (action.payload) {
        const codeName = action.payload.code + '_' + action.payload.urn;
        newNotices[codeName] && delete newNotices[codeName];
      } else {
        newNotices = {};
      }

      return {
        ...state,
        notices: { ...newNotices },
      };
    }

    case constants.ADD_ABORT_CONTROLLER: {
      return {
        ...state,
        abortControllers: [...state.abortControllers, action.payload],
      };
    }

    default:
      return state;
  }
};
